<template>
  <router-view name="model" v-bind:key="$route.path"></router-view>
</template>

<script>
export default {
  name: "Model",
};
</script>
